export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/DouyinSansBold.fbecfacd-fa10dc.ttf";